<app-small-tuile
  type="icon"
  icon="fa-kit fa-picto-connect"
  [title]="'P00045.card.state.link.title' | translate"
  [content]="buttons[this.actionStack!.getValue('cnSEtatConnexionMQTT')].icon!"
  [color]="buttons[this.actionStack!.getValue('cnSEtatConnexionMQTT')].color!"
  [status]="
    buttons[this.actionStack!.getValue('cnSClientConnecte')].title! | translate
  "
  [statusMode]="
    buttons[this.actionStack!.getValue('cnSClientConnecte')].status!
  "
  (onPress)="this.openProductModal()"
>
</app-small-tuile>
